import { render, staticRenderFns } from "./ValidCards.vue?vue&type=template&id=5644b6dd&scoped=true"
import script from "./ValidCards.vue?vue&type=script&lang=js"
export * from "./ValidCards.vue?vue&type=script&lang=js"
import style0 from "./ValidCards.vue?vue&type=style&index=0&id=5644b6dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5644b6dd",
  null
  
)

export default component.exports